import { ArrowLeft } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export function BackButton({ onClick }: { onClick: () => void }) {
	const { t } = useTranslation();

	return (
		<Button
			variant="ghost"
			size="icon"
			onClick={onClick}
			aria-label={t("common.back")}
		>
			<ArrowLeft className="size-4" />
		</Button>
	);
}
